// mantine
import { Button, Table } from '@mantine/core';
// utils
import type { TVersionControlRegistryItem } from '@/services/bff/bff.queries';

interface RegistryItemProps {
    item: TVersionControlRegistryItem;
    onVersionsShow: () => void;
}

const RegistryItem = ({ item, onVersionsShow }: RegistryItemProps) => {
    const version = 'version' in item ? item.version : item.latest_version;
    const subscriptions =
        'subscriptions' in item ? item.subscriptions : undefined;

    return (
        <Table.Tr>
            <Table.Td className="truncate">{item.idn}</Table.Td>
            <Table.Td>{version}</Table.Td>
            <Table.Td>{subscriptions ?? '—'}</Table.Td>
            <Table.Td>
                <Button size="xs" onClick={onVersionsShow}>
                    Version History
                </Button>
            </Table.Td>
        </Table.Tr>
    );
};

export default RegistryItem;
